


























import { MScheduleSlot } from '@api/models/meetings-schedule/MeetingsScheduleSlot';
import { UserProfile } from '@api/models/UserProfile';
import { DateTime } from 'luxon';
import {Vue, Component, Prop, Watch } from 'vue-property-decorator';
import MeetingSlot from "./MeetingSlot.vue";
import SlotActions from "./actions/SlotActions.vue";

@Component({
    name: 'StatefullSlot',
    components: { MeetingSlot, SlotActions }
})
export default class StatefullSlot extends Vue {

    @Prop({ required: true }) source: MScheduleSlot;
    @Prop({ default: false }) isBlocked: boolean;
    @Prop({ default: false }) isSpeaker: boolean;
    @Prop() profile: UserProfile | undefined;

    click() {
        this.getClickIsEnabled() && this.$emit('click')
    }

    disable() {
        this.click();
    }

    enable() {
        this.click();
    }

    @Watch("source.ownerId")
    watchOwnerId(value: boolean | null, prevValue: boolean | null) {
        if(!value && prevValue === this.userId) {
            this.$emit("unblockSchedule")
        }
    }

    getClickIsEnabled() {

        //speaker can't interat with booked slots
        if(this.isSpeaker && this.isBusy) {
            return false
        }

        /**
         * block click for all except member slot with isMine equal true
         */
        if(this.isBlocked && !this.isMine) {
            return false;
        }

        /* MEMBER */
        if(!this.isAdminOrSpeaker && this.isNotAvailable) {
            return false;
        }

        return true
    }

    get needRenderOverlay() {
        return this.getClickIsEnabled();
    }

    get beginAt() {
        return this.source.beginAt
    }

    get beginTime() {
        return this.beginAt instanceof DateTime ? this.beginAt.toFormat("HH:mm") : this.beginAt;
    }

    /**
     * This field need for display slot with current user profile, which booked this slot
     */
    private get isMine(): boolean {

        // speaker or admin can't book slot
        if(this.adminOrSpeakerIsOwner) {
            return false;
        }

        const isMine = this.source.ownerId === this.userId;

        if(isMine) {
            this.$emit("blockSchedule")
        }

        return isMine;
    }

    /**
     * This filed need for displaying slot with user profile, which booked slot
     * Displayed only for speaker or admin
     */
    private get isBusy(): boolean {

        if(this.adminOrSpeakerIsOwner && !this.source.ownerId) {
            return false;
        }

        return this.source.ownerId !== this.userId && Boolean(this.profile)
    }

    private get isAdminOrSpeaker() {
        return this.isAdmin || this.isSpeaker
    }

    /**
     * owners - slot creaators - admin or speaker
     */
    private get adminOrSpeakerIsOwner() {
        return this.isAdminOrSpeaker && this.source.ownerId === this.userId;
    }

    /**
     * признак недоступности
     */
    private get isNotAvailable(): boolean {
        /**
         * занятый слот должен выглядеть недоступным, но только не для админа или спикерв
         */
        const busy = ((Boolean(this.source.ownerId)) && !this.isAdminOrSpeaker);

        return (this.source.isNotAvailable || this.isBlocked || busy) && !this.isMine
    }

    get showProfile() {
        return Boolean((this.isBusy || this.isMine) && this.profile && (!this.isNotAvailable || this.isMine))
    }

    /**
     * моификатор для стилизации состояния
     */
    get stateClass(): string {
        let className = "";

        if(this.isBusy)         {className = "meeting-slot_is-busy";}
        if(this.isNotAvailable) {className = "meeting-slot_is-not-available";}
        if(this.isMine)         {className = "meeting-slot_is-mine";}

        if(this.isAdmin)        {className = className + " meeting-slot_is-admin";}
        if(this.isSpeaker)      {className = className + " meeting-slot_is-speaker";}
        if(this.isBlocked)      {className = className + " meeting-slot_is-blocked";}

        return className;
    }

    private get isAdmin(): boolean {
        return this.$store.getters['isAdmin'];
    }

    private get userId() {
        return this.$store.state.session.userId;
    }
}

